import { createSlice } from "@reduxjs/toolkit"

import { generateSetPropReducer } from "../../../redux/shared/set-setate-prop.reducer.ts"
import { logout } from "../../LoginPage/redux/auth.thunks.ts"
import { permissionsSliceName } from "./permissions.constants"
import { fetchPermissionsDisplay } from "./permissions.thunks.ts.ts"
import { type PermissionsReduxState } from "./permissions.types"

const initialState: PermissionsReduxState = {
  // roles: [],
  // permissions: null,
  // activeRoleId: null,
  fetching: false,
  saveFetching: false,
  error: null,
  permissionsDisplay: null
}

export const permissionsSlice = createSlice({
  name: permissionsSliceName,
  initialState,
  reducers: {
    permissionsSetProp: generateSetPropReducer<PermissionsReduxState>()
  },
  extraReducers: (builder) => {
    // addPrimitiveCases(builder, createRole, "saveFetching")

    builder
      .addCase(fetchPermissionsDisplay.fulfilled, (state, action) => {
        state.permissionsDisplay = action.payload
      })
      // logout
      .addCase(logout.fulfilled, () => initialState)
  }
})

export const { permissionsSetProp } = permissionsSlice.actions

export default permissionsSlice
